import * as React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import * as actions from "../../store/cases/actions";
import { Case, User, Category } from "../../api/classes";
import CaseListItem from "../../pages/cases/caseListItem";
import { List, TextField, IconButton } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CreateCaseDialog from "./createCase";
interface Props {
  open: boolean;
  cases: Case[];
  onClose: () => void;
  onSelect: (caseID: number) => void;
  users: User[];
  categories: Category[];
  fetchCases: () => void;
  fetchUsers: () => void;
  fetchCategories: () => void;
}

class CasePicker extends React.Component<Props> {
  state = {
    open: this.props.open,
    scroll: "paper",
    query: "",
    showNewCase: false
  };
  componentWillReceiveProps(next: Props) {
    if (!this.props.open && next.open) {
      this.setState({ open: next.open });
    }
  }
  componentWillMount() {
    if (!this.props.cases) {
      this.props.fetchCases();
    }
    if (!this.props.users) {
      this.props.fetchUsers();
    }
    if (!this.props.categories) {
      this.props.fetchCategories();
    }
  }
  handleClose = () => {
    this.setState({ open: false, query: "" });
    this.props.onClose();
  };

  render() {
    return (
      <div>
        {this.state.showNewCase && (
          <CreateCaseDialog
            open={this.state.showNewCase}
            onCreate={caseID => {
              this.props.onSelect(caseID);
              this.setState({ showNewCase: false, open: false });
              this.props.fetchCases();
            }}
            onClose={() => this.setState({ showNewCase: false })}
          />
        )}
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          scroll={"paper"}
          aria-labelledby="scroll-dialog-title"
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: { height: "100%" }
          }}
          style={{ height: "100%" }}
        >
          <DialogTitle id="scroll-dialog-title">
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ flex: 1 }}>Search Case</span>
              <IconButton onClick={() => this.setState({ showNewCase: true })}>
                <AddIcon />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent>
            <TextField
              placeholder="Search"
              autoFocus
              onChange={e =>
                this.setState({ query: e.target.value.toLocaleLowerCase() })
              }
              style={{ width: "100%" }}
              fullWidth
            />
            <List
              style={{
                flex: 1,
                width: "100%",
                height: "100%"
              }}
            >
              {!this.props.cases || !this.props.categories || !this.props.users
                ? "Loading"
                : this.props.cases
                    .filter((c, i, ar) => {
                      if (
                        c.title.toLocaleLowerCase().indexOf(this.state.query) >
                        -1
                      ) {
                        //   ar.push(c);
                        return true;
                      }
                      return false;
                    })
                    .sort((a, b) => {
                      return b.id - a.id;
                    })
                    .slice(0, 20)
                    .map(c => {
                      return (
                        <CaseListItem
                          onClick={() => {
                            this.props.onSelect(c.id);
                            this.setState({ open: false });
                          }}
                          case={c}
                          users={this.props.users}
                          categories={this.props.categories}
                        />
                      );
                    })}
            </List>
            <div
              style={{
                marginLeft: 0,
                marginRight: 0,
                marginBottom: 0,
                flex: 1
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default connect(
  (state: GlobalState, own: Props) => ({
    cases: state.cases.list,
    users: state.cases.users,
    categories: state.cases.categories
  }),
  dispatch => ({
    fetchCases: (): any => dispatch(actions.fetchCases()),
    fetchUsers: (): any => dispatch(actions.fetchUsers()),
    fetchCategories: (): any => dispatch(actions.fetchCategories())
  })
)(CasePicker);



// WEBPACK FOOTER //
// ./src/components/dialogs/casePicker.tsx